import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Card, Container, Stack, Typography } from '@mui/material';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CiExport } from "react-icons/ci";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DeleteModel from '../../../components/Deletemodle';
import TableStyle from '../../../components/TableStyle';
import Iconify from '../../../components/iconify';
import { fetchProjectTypeData } from '../../../redux/slice/projectTypeSlice';
import { deleteManyApi } from '../../../service/api';
import { commonUtils } from '../../../utils/utils';
import AddProjectType from './Add';
import EditModel from './Edit';

// ----------------------------------------------------------------------

function CustomToolbar({ selectedRowIds, fetchProjectTypeData }, userRole) {
  const [opendelete, setOpendelete] = useState(false);
  const dispatch = useDispatch()

  const handleCloseDelete = () => {
    setOpendelete(false)
  }

  const handleOpenDelete = () => {
    setOpendelete(true)
  }

  const deleteManyContact = async (data) => {
    await deleteManyApi('api/projecttypes/deletemany', data)
    dispatch(fetchProjectTypeData())
    handleCloseDelete();
  }

  return (
    <GridToolbarContainer>
      <Box padding={"10px 0"}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector
          slotProps={{ tooltip: { title: 'Change density' } }}
        />

        {userRole !== "user" && (selectedRowIds && selectedRowIds.length > 0 && <Button variant="text" sx={{ textTransform: 'capitalize', fontSize: "13", padding: "4px 5px 2px  0", marginRight: "3px" }} startIcon={<DeleteIcon style={{ fontSize: '19px', marginLeft: "8px", marginBottom: "2px" }} />} onClick={handleOpenDelete}>Delete</Button>)}
      </Box>
      <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deleteManyContact} id={selectedRowIds} />
    </GridToolbarContainer>
  );
}


const ProjectType = () => {

  const [typeData, setTypeData] = useState([]);
  const [userAction, setUserAction] = useState(null)
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const [openAdd, setOpenAdd] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userid = sessionStorage.getItem('user_id')
  const userRole = sessionStorage.getItem("userRole")

  const { data, isLoading } = useSelector((state) => state?.projectTypeDetails)
  // open add model
  const [openEdit, setOpenEdit] = useState(false);

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelectionChange = (selectionModel) => {
    setSelectedRowIds(selectionModel);
  };


  const columns = [
    {
      field: "type_name",
      headerName: "Project Type",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        const handleFirstNameClick = () => {
          navigate(`/dashboard/projecttype/view/${params.id}`)
        };

        return (
          <Box onClick={handleFirstNameClick}>
            {params.value}
          </Box>
        );
      }
    },
    {
      field: "charge",
      headerName: "Project Cost",
      flex: 1,
    },
    {
        field: "createdOn",
        headerName: "Created On",
        flex: 1,
        valueFormatter: (params) => {
            const date = new Date(params.value);
            return date.toDateString();
        },
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params) => {
          const handleFirstNameClick = async (data) => {
              setTypeData(data)
              handleOpenEdit();
          };
          return (
              <Box>
                  <Stack direction={"row"} spacing={2}>
                      <Button variant='text' size='small' color='primary' onClick={() => handleFirstNameClick(params?.row)}><EditIcon /></Button>
                  </Stack>
              </Box>
          );
      }
  },

  ];

  const csvColumns = [
    { Header: "Project Type", accessor: 'type_name' },
    { Header: "Project Cost", accessor: "charge" },
    { Header: "Created On", accessor: 'createdOn', type: 'date' },
  ];

  const downloadCsvOrExcel = async (extension, selectedIds) => {
    const formatDateOfBirth = (dateString, filednm) => {
      return moment(dateString).format('DD/MM/YYYY HH:MM A')
    };

    const formatRecords = (records) => {
      return records.map((rec) => {
        const selectedFieldsData = {};
        csvColumns?.forEach((item) => {
          if (item?.type === 'date') {
            selectedFieldsData[item?.accessor] = formatDateOfBirth(rec[item?.accessor]);
          }
          else {
            selectedFieldsData[item?.accessor] = rec[item?.accessor];
          }
        });
        return selectedFieldsData;
      });
    };

    if (selectedIds && selectedIds?.length > 0) {
      const selectedRecordsWithSpecificFileds = formatRecords(data?.filter((rec) => selectedIds?.includes(rec._id)));
      commonUtils.convertJsonToCsvOrExcel({ jsonArray: selectedRecordsWithSpecificFileds, csvColumns, fileName: "Project", extension, setSelectedRowIds });
    } else {
      const AllRecordsWithSpecificFileds = formatRecords(data);
      commonUtils.convertJsonToCsvOrExcel({ jsonArray: AllRecordsWithSpecificFileds, csvColumns, fileName: "Project", extension, setSelectedRowIds });
    }
  };
  const handleExportProject = (extension) => {
    if (selectedRowIds && selectedRowIds?.length > 0) {
      downloadCsvOrExcel(extension, selectedRowIds)
    } else {
      downloadCsvOrExcel(extension);
    }
  };

  useEffect(() => {
    dispatch(fetchProjectTypeData());
  }, [userAction])

  return (
    <>
      <AddProjectType open={openAdd} handleClose={handleCloseAdd} setUserAction={setUserAction} />
      <EditModel open={openEdit} handleClose={handleCloseEdit} typeData={typeData} setUserAction={setUserAction} />

      <Container maxWidth>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" >
            Project Type
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
              Add New
            </Button>
            <Button variant="contained" startIcon={<CiExport icon="eva:plus-fill" />} onClick={() => { handleClose(); handleExportProject('xlsx') }}>
              {selectedRowIds && selectedRowIds?.length > 0 ? 'Export Selected Data' : 'Export'}
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            {isLoading ? (
              <Card style={{ display: 'flex', justifyContent: 'center', height: "600px" }}>
                <span className="loader" />
              </Card>
            ) : (
              <Card style={{ height: "600px" }}>
                <DataGrid
                  rows={data}
                  columns={columns}
                  components={{ Toolbar: () => CustomToolbar({ selectedRowIds, fetchProjectTypeData }, userRole) }}
                  checkboxSelection
                  onRowSelectionModelChange={handleSelectionChange}
                  rowSelectionModel={selectedRowIds}
                  getRowId={row => row._id}
                />
              </Card>
            )}


          </Box>
        </TableStyle>
      </Container>
    </>
  );
}

export default ProjectType